import styled from 'styled-components';

import Button from '../Button';
import { theme } from '../GlobalStyles';
import { Contain } from '../Grid';

const SC = {};

SC.Contain = styled(Contain)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

SC.PromoCardWrapper = styled.div`
  height: 100%;
  padding: 0.625rem;
  ${theme.mediaQueries.below.small} {
    padding: 0;
  }
`;

SC.LoadMore = styled(Button)`
  padding: 0.75rem 1.125rem;
  border-radius: 1.5rem;
  width: 100%;
  ${theme.mediaQueries.above.xlarge} {
    width: auto;
  }
`;

const promoElements = {
  ...SC,
};

export default promoElements;
